import {FACTIONS} from "../../../constants/factions";

// TODO.ENLIGHTENED: Добавить цитаты
export const ENLIGHTENED_QUOTES = [{
  quote: 'Шашлык без лука...',
  author: 'Ясос Безликий, просветленный-умник Города-Пермь',
  factionId: FACTIONS.ENLIGHTENED
}]